export default __webpack_public_path__ + "static/media/invoiceList.98ebe282.png";